const backgroundImageMaxHeightInPx = 600;
const wrapper = "_35swx3bw4u";
const canvas = "_35sc1u9sglz";
const inputs = "_35siydi16e";
const contextMenu = "_35sckgnkts";
const background = "_35sbar3q0z";

export { background, backgroundImageMaxHeightInPx, canvas, contextMenu, inputs, wrapper };
import "./organism.canvas.style.linaria.module.css";
//# sourceMappingURL=organism.canvas.style.js.map
